import { Reveal } from './reveal';
import { Botao } from './botao';
import { CapturaInteresse } from './captura-interesse';
import { URL_APP } from '../dados/navegacao';

/** CTA final antes do rodapé — mesma tese do herói, fechando o argumento. */
export function CtaFinal(): JSX.Element {
  /*
    Última seção abaixo da dobra, e a única que não passa pela moldura `Secao`
    — por isso `adia-render` e a altura estimada vêm escritos aqui. A altura
    foi MEDIDA no navegador; chutar faria a barra de rolagem pular.
  */
  return (
    <section
      id="contato"
      className="adia-render scroll-mt-24 py-20 sm:py-28"
      style={{ containIntrinsicSize: 'auto 720px' }}
    >
      <div className="mx-auto max-w-3xl px-6 text-center">
        <Reveal peso="forte" className="flex flex-col items-center gap-6">
          <h2 className="text-auth-texto text-3xl font-medium tracking-[-0.03em] text-balance sm:text-4xl">
            O documento nunca é a verdade.{' '}
            <span className="text-auth-marca-hover font-semibold">
              O estado da sociedade é.
            </span>
          </h2>
          <p className="text-auth-texto-secundario max-w-xl text-base leading-relaxed">
            Comece o teste grátis de <span className="font-semibold tabular-nums">7</span>{' '}
            dias e traga o próximo contrato para o sistema, não para o Word.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-4">
            {/* Mesmo destino do herói: o autocadastro existe. Este botão
                apontava para `#contato` — a PRÓPRIA seção: o clique não fazia
                nada visível, um CTA morto no fechamento do argumento. */}
            <Botao href={`${URL_APP}/criar-conta`} variante="primario">
              Quero testar
            </Botao>
            <Botao href="mailto:contato@specializer.com.br" variante="fantasma">
              Falar com a gente
            </Botao>
          </div>

          <div className="border-auth-borda/8 mt-4 w-full max-w-md border-t pt-6">
            <p className="text-auth-texto-secundario mb-3 text-sm">
              Ainda não é hora? Deixe seu e-mail e avisamos quando o cadastro abrir.
            </p>
            <CapturaInteresse origem="cta-final" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
